import { ApplicationQuestion, FieldType, TextField, TextInputType } from '@bybeam/platform-types';
import { makeEduConfig } from './baseConfig.js';

const CONFIG = makeEduConfig();

const personalInfoSection = CONFIG.sections.find(({ key }) => key === 'personalInfo');

const studentInfoQuestionGroup = personalInfoSection.questionGroups.find(
  ({ key }) => key === 'studentInfo',
);

// Update student ID question to match Minnesota specific ID

const studentIdQuestion = studentInfoQuestionGroup.questions.find(({ key }) => key === 'studentId');
studentIdQuestion.copy.title = 'What is your STAR ID?';
const fields = studentIdQuestion.fields[0] as TextField;
fields.copy = 'STAR ID';

// Add skippable question to ask student for tech ID

const newQuestion: { [key: string]: ApplicationQuestion } = {
  techId: {
    key: 'techId',
    copy: { title: 'What is your Tech ID?' },
    skippable: true,
    fields: [
      {
        type: FieldType.Text,
        inputType: TextInputType.Text,
        validation: { required: false },
        copy: 'Tech ID',
        key: 'techId',
      },
    ],
  },
};

newQuestion.techId.fields.filter(({ key }) => key !== 'required_helper');
studentInfoQuestionGroup.questions.push(newQuestion.techId);

const indexOfReview = CONFIG.sections.findIndex(({ key }) => key === 'review');
const indexOfDocuments = CONFIG.sections.findIndex(({ key }) => key === 'documents');
const indexOfYouAndYourSituation = CONFIG.sections.findIndex(
  ({ key }) => key === 'youAndYourSituation',
);

const newReviewSection = structuredClone(CONFIG.sections[indexOfReview]);
const newDocumentSection = structuredClone(CONFIG.sections[indexOfDocuments]);
const newYouAndYourSituationSection = structuredClone(CONFIG.sections[indexOfYouAndYourSituation]);

const newAffirmationQuestionGroup = newReviewSection.questionGroups.find(
  ({ key }) => key === 'affirmation',
);

const newYouAndYourSituationGroup = newYouAndYourSituationSection.questionGroups.find(
  ({ key }) => key === 'youAndYourSituation',
);

newYouAndYourSituationGroup.questions.pop();
newYouAndYourSituationGroup.questions.push({
  key: 'additionalInformation',
  copy: {
    title: 'Additional Information',
    intro:
      'Please use this space to share additional information about the emergency you are experiencing.',
  },
  fields: [
    {
      type: FieldType.Text,
      inputType: TextInputType.Text,
      key: 'additionalInformation',
      copy: 'Comments',
      props: { multiline: true, rows: 5 },
    },
  ],
});

const newAffirmationQuestion: { [key: string]: ApplicationQuestion } = {
  reviewerAffirmation: {
    key: 'reviewerAffirmation',
    copy: {
      title: 'Before submitting the application, please confirm this statement:',
      intro: 'Please review and confirm the statement by selecting the checkbox below.',
    },
    fields: [
      {
        type: FieldType.Checkbox,
        key: 'reviewerAffirmation',
        copy: 'I understand the reviewer(s) of this application may consult with the financial aid office regarding the status of my financial aid application and/or any financial aid eligibility I may have.',
      },
    ],
  },
};

newDocumentSection.questionGroups[0].questions[0].skippable = true;
newAffirmationQuestionGroup.questions.push(newAffirmationQuestion.reviewerAffirmation);

// Swap the existing review section with the deep cloned copy
CONFIG.sections[indexOfYouAndYourSituation] = newYouAndYourSituationSection;
CONFIG.sections[indexOfDocuments] = newDocumentSection;
CONFIG.sections[indexOfReview] = newReviewSection;
CONFIG.overrides = {
  statuses: [
    {
      status: 'Denied',
      label: 'Status: Application Decision',
      message:
        'Unfortunately, {PARTNER_NAME} is unable to provide you with funds at this time. If you have any questions about this decision, you can contact {PARTNER_NAME} at {PARTNER_EMAIL}.',
    },
  ],
};

export default CONFIG;
